import type { ForwardedRef, TextareaHTMLAttributes } from 'react'
import { forwardRef } from 'react'
import style from './style.module.sass'

export const Textarea = forwardRef(
	(
		{ className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>,
		ref: ForwardedRef<HTMLTextAreaElement>
	) => {
		return (
			<textarea
				{...rest}
				ref={ref}
				data-yakiniku="textarea"
				className={`control ${style.textarea} ${className || ''}`}
			/>
		)
	}
)
